"use client"

import { useParams, Outlet } from "react-router-dom"
import NavbarCircuito from "../../components/NavbarCircuito"
import BotaoWhatsApp from "../../components/BotaoWhatsApp"
import { CircuitoProvider, CircuitoContext } from "../../context/CircuitoContext"
import { useContext, createContext } from "react"
import "../../styles/circuitoDesignSystem.css"

export const DomainContext = createContext({ basePath: "", slugAtivo: "" })

function CircuitoShell() {
  const { circuito } = useContext(CircuitoContext)

  return (
    <div
      className="circuito-shell"
      style={{
        "--cor-primaria": circuito?.corPrimaria || "#d4af37",
        "--cor-secundaria": circuito?.corSecundaria || "#111111",
        "--bg-primario": circuito?.bgPrimario || "#0f0f0f",
        "--bg-secundario": circuito?.bgSecundario || "#171717",
        "--texto-primario": circuito?.textoPrimario || "#ffffff",
        "--texto-botao": circuito?.botaoTexto || "#000000",
        "--c-top": circuito?.corPrimaria,
        "--c-accent": circuito?.corPrimaria,
        "--c-bg": circuito?.bgPrimario,
        "--c-card": circuito?.bgSecundario,
        "--c-text": circuito?.textoPrimario,
      }}
    >
      <NavbarCircuito />
      <main className="circuito-main">
        <Outlet />
      </main>
      <BotaoWhatsApp />
    </div>
  )
}

export default function LayoutCircuito({ customSlug }) {
  const { slug: urlSlug } = useParams()
  
  const slugAtivo = customSlug || urlSlug
  const basePath = customSlug ? "" : `/circuito/${slugAtivo}`

  return (
    <DomainContext.Provider value={{ basePath, slugAtivo }}>
      <CircuitoProvider slug={slugAtivo}>
        <CircuitoShell />
      </CircuitoProvider>
    </DomainContext.Provider>
  )
}